(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fiozato-footer"]) return;
  try {
    
function fiozatoFooterBreakpoints(){const desktop=matchMedia('(min-width:750px)').matches;document.querySelectorAll('.ff-group').forEach(d=>{if(desktop){const m=window.FiozatoDisclosures;if(m)m.cancel(m.detailsStates,d);d.removeAttribute('data-disclosure-opening');d.open=true;d.dataset.desktop='true';return;}if(d.dataset.desktop!=='false'){d.open=false;d.dataset.desktop='false';}});}
function fiozatoFooterAccordions(){document.querySelectorAll('.ff').forEach(footer=>{if(footer.dataset.accordionReady)return;footer.dataset.accordionReady='true';footer.querySelectorAll('.ff-group').forEach(group=>{const only=()=>{if(!group.open||!matchMedia('(max-width:749px)').matches)return;const top=group.getBoundingClientRect().top;footer.querySelectorAll('.ff-group[open]').forEach(other=>{if(other===group)return;if(other.compareDocumentPosition(group)&Node.DOCUMENT_POSITION_FOLLOWING){const m=window.FiozatoDisclosures;if(m)m.cancel(m.detailsStates,other);other.removeAttribute('data-disclosure-opening');other.open=false;}else if(window.FiozatoDisclosures)window.FiozatoDisclosures.close(other);else other.open=false;});const d=group.getBoundingClientRect().top-top;if(d)window.scrollBy(0,d);};group.addEventListener('toggle',only);group.firstElementChild.addEventListener('click',()=>{if(group.dataset.disclosureOpening==='true')only();});});});}
function fiozatoFooterNewsletter(){document.querySelectorAll('.ff-newsletter form').forEach(form=>{const input=form.querySelector('input[type="email"]'),button=form.querySelector('button[type="submit"]');if(!input||!button)return;const sync=()=>{delete form.dataset.sending;button.disabled=input.value.trim()==='';};if(!form.dataset.newsletterReady){form.dataset.newsletterReady='true';input.addEventListener('input',sync);input.addEventListener('change',sync);form.addEventListener('submit',e=>{if('sending' in form.dataset){e.preventDefault();e.stopImmediatePropagation();return;}form.dataset.sending='';clearTimeout(form.fzSending);form.fzSending=setTimeout(sync,5000);if(!form.dataset.hcaptchaBound&&window.Shopify?.captcha)Shopify.captcha.protect(form,()=>form.submit());});}sync();});}
function fiozatoFooterInit(){fiozatoFooterBreakpoints();fiozatoFooterAccordions();fiozatoFooterNewsletter();}
fiozatoFooterInit();window.addEventListener('pageshow',e=>{if(e.persisted)fiozatoFooterInit();else fiozatoFooterNewsletter();});document.addEventListener('shopify:section:load',fiozatoFooterInit);matchMedia('(min-width:750px)').addEventListener('change',fiozatoFooterBreakpoints);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fiozato-header"]) return;
  try {
    
class FiozatoNavigation extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.abort = new AbortController();
  const signal = this.abort.signal;
  this.mobile = this.querySelector('.fn-mobile-dialog');
  this.search = this.querySelector('.fn-search-dialog');
  this.panelScrollToken = {};
  this.panelAnimations = new WeakMap();
  this.panelLeaveTimer = 0;
  this.panelMotionVersion = 0;
  this.triggers = [...this.querySelectorAll('[data-panel-trigger]')];
  this.panels = [...this.querySelectorAll('.fn-panel')];
  this.shade = this.querySelector('[data-shade]');
  this.bar = this.querySelector('.fn-bar');
  this.desktopNav = this.querySelector('.fn-desktop');
  this.topLinks = [...this.querySelectorAll('.fn-top-link')];
  this.desktopQuery = matchMedia('(min-width:1100px)');
  this.eagerCards = () => this.panels.forEach(p => p.querySelectorAll('img[loading=lazy]').forEach(i => { i.loading = 'eager'; }));
  if (this.desktopQuery.matches) window.addEventListener('load', this.eagerCards, {once:true, signal});
  this.pointerType = '';
  this.hoverStale = true;
  window.addEventListener('pageshow', event => { if (event.persisted) this.hoverStale = true; }, {signal});
  document.addEventListener('close', () => { this.hoverStale = true; }, {signal, capture:true});
  document.addEventListener('pointermove', event => { const moved = event.clientX !== this.px || event.clientY !== this.py; this.hoverStale = !moved; if (moved && event.pointerType === 'mouse') this.pointerType = 'mouse'; this.px = event.clientX; this.py = event.clientY; if (event.pointerType === 'mouse') this.movedSinceOpen = true; }, {signal, capture:true, passive:true});
  this.addEventListener('pointerdown', event => { this.pointerType = event.pointerType; }, {signal, capture:true});
  const release = () => { if (this.pressRow && this.pressRow !== this.pressedRow) this.pressRow.removeAttribute('data-pressed'); this.pressRow = null; };
  this.mobile.addEventListener('pointerdown', event => { const row = event.target.closest('a.fn-mobile-row,.fn-mobile-footer>a'); if (!row || !event.isPrimary) return; clearTimeout(this.pressTimer); release(); this.pressRow = row; row.setAttribute('data-pressed', ''); }, {signal, passive:true});
  this.mobile.addEventListener('pointercancel', release, {signal, passive:true});
  this.mobile.addEventListener('pointerup', () => { clearTimeout(this.pressTimer); if (this.pressRow) this.pressTimer = setTimeout(release, 700); }, {signal, passive:true});
  this.addEventListener('click', event => {
   if (performance.now() < this.pageArmedAt && event.target.closest('.fn-mobile-body')) { event.preventDefault(); return; }
   const trigger = event.target.closest('[data-panel-trigger]');
   if (trigger) { if (trigger === this.activeTrigger && this.openPanel) { if (this.pointerType !== 'mouse') this.showPanel(null); } else this.showPanel(trigger); }
   else if (this.openPanel && !event.target.closest('.fn-panel')) this.showPanel(null);
   if (event.target.closest('[data-mobile-open]')) { this.stack=[]; this.mobilePage('root'); this.openDialog(this.mobile); }
   const mobileClose = event.target.closest('[data-mobile-close]');
   if (mobileClose && !(mobileClose.matches('[data-root-symbol]') && performance.now() < this.symbolArmedAt)) window.FiozatoDialogs.close(this.mobile);
   const next = event.target.closest('[data-mobile-next]');
   if (next) { this.stack.push({page:this.page,title:this.pageTitle,opener:next}); this.mobilePage(next.dataset.mobileNext,next.dataset.title,1); this.querySelector('[data-mobile-back]').focus({preventScroll:true}); }
   if (event.target.closest('[data-mobile-back]')) { const previous=this.stack.pop(); if(previous) { this.mobilePage(previous.page,previous.title,-1); previous.opener.focus({preventScroll:true}); } }
   if (event.target.closest('[data-search-open]')) { this.openDialog(this.search); this.search.querySelector('fiozato-search')?.search?.(); this.search.querySelector('input[type="search"]').focus({preventScroll:true}); }
   const row = event.target.closest('a.fn-mobile-row,.fn-mobile-footer>a');
   if (row) { clearTimeout(this.pressTimer); this.pressRow = null; if (!event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { this.mobile.querySelectorAll('[data-pressed]').forEach(node => node !== row && node.removeAttribute('data-pressed')); row.setAttribute('data-pressed', ''); this.pressedRow = row; } else if (row !== this.pressedRow) row.removeAttribute('data-pressed'); }
   const close = event.target.closest('[data-dialog-close]');
   if (close) window.FiozatoDialogs.close(close.closest('dialog'));
  }, {signal});
  this.addEventListener('keydown',event=>{
   this.pointerType='';
   const trigger=event.target.closest('[data-panel-trigger]');
   if(trigger && event.key==='ArrowDown') { event.preventDefault(); this.showPanel(trigger,true); document.getElementById(trigger.dataset.panelTrigger).querySelector('a')?.focus(); }
   if(event.key==='Tab'&&this.openPanel&&this.activeTrigger){
    const items=this.openPanel.querySelectorAll('a'),back=event.shiftKey;
    if(back&&event.target===this.topLinks[0])this.showPanel(null);
    const to=event.target===this.activeTrigger&&!back?items[0]:event.target===items[0]&&back?this.activeTrigger:event.target===items[items.length-1]&&!back?this.topLinks[this.topLinks.indexOf(this.activeTrigger)+1]:null;
    if(to){event.preventDefault();to.focus();}
   }
  },{signal});
  document.addEventListener('keydown',event=>{
   if(event.key!=='Escape'||!this.openPanel)return;
   const trigger=this.activeTrigger,inside=this.contains(document.activeElement);
   this.hoverBlocked=trigger?.matches(':hover')?trigger:null;
   this.showPanel(null);
   if(inside&&trigger)trigger.focus();
  },{signal});
  this.topLinks.forEach(trigger=>{
   const hover=event=>{
    if(event.pointerType!=='mouse' || !this.desktopQuery.matches || this.hoverStale || this.hoverBlocked===trigger || this.activeTrigger===trigger)return;
    if(this.swapTrigger===trigger)return;
    clearTimeout(this.swapTimer);
    this.swapTrigger=trigger;
    this.swapTimer=setTimeout(()=>this.showPanel(trigger),100);
   };
   trigger.addEventListener('pointerleave',()=>{if(this.hoverBlocked===trigger)this.hoverBlocked=null;if(this.swapTrigger===trigger){clearTimeout(this.swapTimer);this.swapTrigger=null;}},{signal});
   trigger.addEventListener('pointermove',hover,{signal,passive:true});
  });
  this.bar.addEventListener('pointermove',event=>{
   if(event.pointerType!=='mouse'||!this.openPanel)return;
   const nav=this.desktopNav.getBoundingClientRect();
   if(event.clientX>=nav.left&&event.clientX<=nav.right)this.cancelPanelClose();else if(!this.panelLeaveTimer)this.schedulePanelClose(false);
  },{signal,passive:true});
  this.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'&&this.movedSinceOpen)this.schedulePanelClose();},{signal});
  this.panels.forEach(panel=>panel.addEventListener('pointerenter',event=>{this.cancelPanelClose();const trigger=this.triggers.find(t=>t.dataset.panelTrigger===panel.id);if(event.pointerType==='mouse'&&!this.openPanel&&!panel.hidden&&this.panelReopenable&&this.hoverBlocked!==trigger)this.showPanel(trigger);},{signal}));
  this.shade.addEventListener('pointermove',event=>{if(event.pointerType==='mouse'&&this.openPanel&&!this.panelLeaveTimer)this.schedulePanelClose();},{signal,passive:true});
  this.addEventListener('focusout',event=>{const to=event.relatedTarget;if(to&&(!this.desktopNav.contains(to)&&!this.panels.some(p=>p.contains(to))||!this.pointerType&&to!==this.activeTrigger&&this.topLinks.includes(to)))this.showPanel(null);},{signal});
  this.desktopNav.addEventListener('focusin',()=>{if(this.headerSection?.hasAttribute('data-fn-hidden')){const y=this.lastScrollY;requestAnimationFrame(()=>scrollTo({top:y,behavior:'instant'}));}this.toggleHeader(false);},{signal});
  this.querySelector('.fa')?.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&this.movedSinceOpen)this.schedulePanelClose();},{signal});
  document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))this.showPanel(null);},{signal});
  window.addEventListener('pagehide',()=>this.showPanel(null,true),{signal});
  this.mobile.addEventListener('close',()=>{clearTimeout(this.pressTimer);this.pressRow=this.pressedRow=null;this.mobile.querySelectorAll('[data-pressed]').forEach(node=>node.removeAttribute('data-pressed'));},{signal});
  this.querySelectorAll('dialog').forEach(dialog=>{
   dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)window.FiozatoDialogs.close(dialog);}},{signal});
  });
  this.headerSection=this.closest('.section-header');this.lastScrollY=Math.max(0,window.scrollY);this.scrollAnchor=this.lastScrollY;this.scrollDirection=0;this.upwardSamples=[];this.inputAt=-1e9;this.headerFrame=0;this.headerViewportWidth=window.innerWidth;this.headerMobile=!this.desktopQuery.matches;
  this.restoringScroll=window.scrollY===0&&['reload','back_forward'].includes(performance.getEntriesByType?.('navigation')[0]?.type);
  this.setBottom=v=>{document.documentElement.dataset.fnBottom=v;if(innerWidth>=750)[this.headerSection,...document.querySelectorAll('fiozato-product')].forEach(el=>el?.style.setProperty('--fn-bottom',`${v}px`));};
  this.measure=()=>{
   const root=document.documentElement;
   if(root.hasAttribute('data-fz-fixed-body'))return;
   const bottom=this.headerSection?.hasAttribute('data-fn-hidden')?0:Math.max(0,this.getBoundingClientRect().bottom);
   if(!this.headerSettle&&bottom!==this.measuredBottom){this.measuredBottom=bottom;this.setBottom(bottom);}
  };
  this.settleMeasure=()=>{clearTimeout(this.headerSettle);this.headerSettle=setTimeout(()=>{this.headerSettle=0;this.measure();},220);};
  this.toggleHeader=hide=>{if(!this.headerSection||this.headerSection.hasAttribute('data-fn-hidden')===hide)return;this.hoverStale=true;this.headerSection.toggleAttribute('data-fn-hidden',hide);const bottom=hide?0:this.offsetHeight-Math.min(window.scrollY,this.querySelector('.fa')?.offsetHeight||0);if(bottom!==this.measuredBottom){this.measuredBottom=bottom;this.setBottom(bottom);}this.settleMeasure();};
  this.syncBreakpoint=()=>{if(this.desktopQuery.matches){this.eagerCards();if(this.mobile.open){this.hoverStale=true;this.mobile.close();}}else this.showPanel(null,true);};
  this.updateMobileHeader=()=>{
   this.headerFrame=0;
   const current=Math.max(0,window.scrollY),mobile=!this.desktopQuery.matches,locked=document.documentElement.hasAttribute('data-fz-scroll-locked');
   if(this.restoringScroll){this.restoringScroll=false;this.scrollAnchor=current;this.scrollDirection=0;this.upwardSamples=[];this.lastScrollY=current;this.measure();this.settleMeasure();return;}
   if(locked){this.scrollAnchor=current;this.scrollDirection=0;this.upwardSamples=[];}
   else if(current<=this.offsetHeight||!mobile&&!document.querySelector('.fc-toolbar')?.offsetParent){this.toggleHeader(false);this.scrollAnchor=current;this.scrollDirection=0;this.upwardSamples=[];}
   else{
    const direction=Math.sign(current-this.lastScrollY);
    if(direction){
     const now=performance.now();
     if(direction!==this.scrollDirection){this.scrollDirection=direction;this.scrollAnchor=this.lastScrollY;this.upwardSamples=direction<0?[{time:now,y:this.lastScrollY}]:[];}
     const hidden=this.headerSection?.hasAttribute('data-fn-hidden');
     if(direction<0&&hidden){
      this.upwardSamples.push({time:now,y:current});
      while(this.upwardSamples.length>1&&now-this.upwardSamples[0].time>180)this.upwardSamples.shift();
      const first=this.upwardSamples[0],distance=first.y-current,elapsed=now-first.time;
      if(this.scrollAnchor-current>=120&&(!mobile?this.scrollAnchor>this.lastScrollY||now-this.inputAt<300:distance>=70&&elapsed>=40&&distance/elapsed>=.7)){
       this.toggleHeader(false);this.scrollAnchor=current;this.upwardSamples=[];
      }
     }else if(direction>0&&!hidden&&current-this.scrollAnchor>=24&&(mobile||document.querySelector('.fc-toolbar').getBoundingClientRect().top<=this.offsetHeight+1)){
      this.toggleHeader(true);this.scrollAnchor=current;
     }
    }
   }
   this.lastScrollY=current;if(!this.headerSettle)this.measure();
  };
  this.onHeaderScroll=()=>{if(!this.headerFrame)this.headerFrame=requestAnimationFrame(this.updateMobileHeader);};
  this.onScrollRestored=event=>{const current=Math.max(0,event.detail?.y??window.scrollY);this.lastScrollY=current;this.scrollAnchor=current;this.scrollDirection=0;this.upwardSamples=[];this.restoringScroll=true;this.settleMeasure();if(current<=2&&!document.documentElement.hasAttribute('data-fz-fixed-body'))this.toggleHeader(false);requestAnimationFrame(()=>requestAnimationFrame(()=>{this.restoringScroll=false;}));};
  this.onHeaderResize=()=>{
   const width=window.innerWidth,mobile=!this.desktopQuery.matches;
   if(Math.abs(width-this.headerViewportWidth)>2||mobile!==this.headerMobile){
    this.headerViewportWidth=width;this.headerMobile=mobile;this.measuredBottom=null;
    this.toggleHeader(false);
    [this.headerSection,...document.querySelectorAll('.fc-toolbar,.fc-mobile-toolbar')].forEach(e=>e?.getAnimations().forEach(a=>a.finish()));
    this.lastScrollY=Math.max(0,window.scrollY);this.scrollAnchor=this.lastScrollY;this.scrollDirection=0;this.upwardSamples=[];
   }
   this.measure();
  };
  window.addEventListener('resize',this.onHeaderResize,{signal});window.addEventListener('scroll',this.onHeaderScroll,{passive:true,signal});window.addEventListener('fiozato:scroll-restored',this.onScrollRestored,{signal});
  window.addEventListener('wheel',e=>{if(e.deltaY<0)this.inputAt=e.timeStamp;},{passive:true,signal});window.addEventListener('keydown',e=>{if(e.key==='PageUp'||e.key==='ArrowUp'||e.key===' '&&e.shiftKey)this.inputAt=e.timeStamp;},{passive:true,signal});
  this.desktopQuery.addEventListener('change',this.syncBreakpoint,{signal});
  this.observer=new ResizeObserver(this.measure);this.observer.observe(this);this.measure();
 }
 schedulePanelClose(reopenable=true) {
  if(!this.openPanel)return;
  clearTimeout(this.panelLeaveTimer);
  this.panelLeaveTimer=setTimeout(()=>{this.panelLeaveTimer=0;this.showPanel(null);this.panelReopenable=reopenable;},110);
 }
 cancelPanelClose() {
  clearTimeout(this.panelLeaveTimer);
  this.panelLeaveTimer=0;
 }
 stopPanelAnimation(node) {
  const animation=this.panelAnimations.get(node);
  if(!animation)return;
  this.panelAnimations.delete(node);
  animation.cancel();
 }
 fadePanelNode(node,to,duration,easing,after) {
  const from=getComputedStyle(node).opacity;
  this.stopPanelAnimation(node);
  if(duration===0){node.style.opacity=to;after?.();return;}
  const animation=node.animate([{opacity:from},{opacity:to}],{duration,easing,fill:'both'});
  this.panelAnimations.set(node,animation);
  animation.finished.then(()=>{
   if(this.panelAnimations.get(node)!==animation)return;
   this.panelAnimations.delete(node);
   node.style.opacity=to;
   animation.cancel();
   after?.();
  }).catch(()=>{});
 }
 resetPanelContent(panel) {
  [...panel.children].forEach(node=>{
   this.stopPanelAnimation(node);
   node.style.removeProperty('opacity');
  });
 }
 fadePanelContent(panel,to,duration,easing,after) {
  const nodes=[...panel.children];
  let pending=nodes.length;
  nodes.forEach(node=>this.fadePanelNode(node,to,duration,easing,()=>{
   pending-=1;
   if(pending===0)after?.();
  }));
 }
 showPanel(trigger,instant=false) {
  clearTimeout(this.swapTimer);this.swapTrigger=null;
  this.cancelPanelClose();
  this.panelReopenable=false;
  if(!trigger&&!this.openPanel&&!instant)return;
  const desktop=this.desktopQuery.matches,quick=instant||!desktop;
  const panel=desktop&&trigger?.dataset.panelTrigger?document.getElementById(trigger.dataset.panelTrigger):null;
  const version=++this.panelMotionVersion;
  this.activeTrigger=trigger;
  this.triggers.forEach(t=>{const expanded=String(t===trigger);if(t.getAttribute('aria-expanded')!==expanded)t.setAttribute('aria-expanded',expanded);});
  if(panel){
   if(!this.openPanel){this.measure();this.movedSinceOpen=false;}
   const current=this.panels.find(item=>!item.hidden)||null;
   const closing=Boolean(current&&!this.openPanel);
   const switching=current&&current!==panel;
   this.openPanel=panel;
   this.panels.forEach(item=>{
    if(item!==current||!switching)this.resetPanelContent(item);
    if(item===current||item===panel)return;
    this.stopPanelAnimation(item);item.hidden=true;
    item.style.removeProperty('opacity');
   });
   if(switching&&(instant||closing||this.panelAnimations.has(current))){
    const from=getComputedStyle(current).opacity;
    this.stopPanelAnimation(current);current.hidden=true;current.style.removeProperty('opacity');this.resetPanelContent(current);
    this.stopPanelAnimation(panel);panel.hidden=false;panel.style.opacity=from;
    this.fadePanelNode(panel,1,240,'ease-out');
   }else if(current===panel){
    if(closing)this.fadePanelNode(panel,1,240,'ease-out');else{this.stopPanelAnimation(panel);panel.style.opacity='1';}
   }else if(switching){
    this.stopPanelAnimation(current);current.style.opacity='1';
    this.stopPanelAnimation(panel);panel.hidden=true;panel.style.removeProperty('opacity');
    this.fadePanelContent(current,.78,60,'ease-out',()=>{
     if(version!==this.panelMotionVersion||this.openPanel!==panel)return;
     current.hidden=true;current.style.removeProperty('opacity');this.resetPanelContent(current);
     panel.hidden=false;panel.style.opacity='1';
     [...panel.children].forEach(node=>node.style.opacity='.78');
     this.fadePanelContent(panel,1,115,'ease-out',()=>{
      if(version!==this.panelMotionVersion||this.openPanel!==panel)return;
      this.resetPanelContent(panel);
     });
    });
   }else{
    this.stopPanelAnimation(panel);panel.hidden=false;panel.style.opacity='0';
    this.fadePanelNode(panel,1,240,'ease-out');
   }
   const shadeWasVisible=!this.shade.hidden;
   this.shade.hidden=false;
   if(!shadeWasVisible)this.shade.style.opacity='0';
   this.fadePanelNode(this.shade,1,240,'ease-in');
   window.FiozatoPageScroll?.lock(this.panelScrollToken);
   return;
  }
  this.openPanel=null;
  this.panels.filter(item=>!item.hidden).forEach(item=>this.fadePanelNode(item,0,quick?0:160,'ease-in',()=>{
   if(version!==this.panelMotionVersion)return;
   item.hidden=true;
   item.style.removeProperty('opacity');
   this.resetPanelContent(item);
  }));
  window.FiozatoPageScroll?.unlock(this.panelScrollToken);
  if(!this.shade.hidden)this.fadePanelNode(this.shade,0,quick?0:120,'ease-in-out',()=>{
   if(version!==this.panelMotionVersion)return;
   this.shade.hidden=true;
   this.shade.style.removeProperty('opacity');
  });
 }
 mobilePage(page,title,direction=0) {
  const motion=window.FiozatoMotion,pages=[...this.querySelectorAll('[data-mobile-page]')];
  const previous=pages.find(node=>node.dataset.mobilePage===this.page),next=pages.find(node=>node.dataset.mobilePage===page);
  const animate=direction&&this.mobile.open;
  const previousTransform=previous&&!previous.hidden?getComputedStyle(previous).transform:'translateX(0)';
  const nextTransform=next.hidden?`translateX(${direction*100}%)`:getComputedStyle(next).transform;
  const heading=this.querySelector('[data-mobile-title]'),read=node=>{const style=getComputedStyle(node);return{transform:style.transform,opacity:style.opacity};};
  const oldTitle=heading.firstElementChild,titleOut=heading.querySelector('[data-title-outgoing]'),newTitle=document.createElement('span');newTitle.textContent=title||heading.dataset.rootTitle;
  const oldFrom=oldTitle&&read(oldTitle),newFrom=titleOut?.textContent===newTitle.textContent?read(titleOut):{transform:`translateY(${direction*100}%)`,opacity:0};
  const leading=this.querySelector('.fn-mobile-leading'),back=leading.querySelector('[data-mobile-back]'),menu=leading.querySelector('[data-root-symbol]');
  const active=back.hidden?menu:back,target=page==='root'?menu:back,iconOut=leading.querySelector('[data-icon-outgoing]');
  const shown=iconOut?(iconOut.dataset.iconOutgoing==='back'?back:menu):active,iconFrom=read(iconOut||active);
  pages.forEach(node=>{motion.finish(node);node.hidden=node!==next;node.inert=node!==next;});
  this.page=page;this.pageTitle=title;
  if(direction>=0)next.scrollTop=0;
  if(page==='root'&&direction)this.symbolArmedAt=performance.now()+350;
  if(animate){
   this.pageArmedAt=performance.now()+300;
   previous.hidden=false;
   motion.run(previous,[{transform:previousTransform},{transform:`translateX(${-direction*100}%)`}],()=>{previous.hidden=true;},300);
   motion.run(next,[{transform:nextTransform},{transform:'translateX(0)'}],null,300);
  }
  heading.querySelectorAll('span').forEach(node=>motion.finish(node));
  heading.replaceChildren(newTitle);
  if(animate&&oldTitle&&oldTitle.textContent!==newTitle.textContent){
   oldTitle.dataset.titleOutgoing='';oldTitle.setAttribute('aria-hidden','true');heading.append(oldTitle);
   motion.run(oldTitle,[oldFrom,{transform:`translateY(${-direction*100}%)`,opacity:0}],()=>oldTitle.remove());
   motion.run(newTitle,[newFrom,{transform:'translateY(0)',opacity:1}]);
  }
  leading.querySelectorAll('[data-icon-outgoing]').forEach(motion.finish);
  motion.finish(back);motion.finish(menu);
  back.hidden=page==='root';menu.hidden=page!=='root';
  if(animate&&active!==target){
   if(shown===target)motion.run(target,[iconFrom,{transform:'scale(1)',opacity:1}],null,140);
   else{
    const icon=shown.querySelector('svg').cloneNode(true);icon.dataset.iconOutgoing=shown===back?'back':'menu';leading.append(icon);
    const glyph=target.querySelector('svg');glyph.style.visibility='hidden';
    motion.run(icon,[iconFrom,{transform:'scale(.55)',opacity:0}],()=>{icon.remove();glyph.style.removeProperty('visibility');motion.run(target,[{transform:'scale(.55)',opacity:0},{transform:'scale(1)',opacity:1}],null,140);},140);
   }
  }
 }
 openDialog(dialog) { if(dialog===this.mobile)this.symbolArmedAt=this.pageArmedAt=performance.now()+350;window.FiozatoDialogs.open(dialog); }
 disconnectedCallback() { this.ready=false;clearTimeout(this.panelLeaveTimer);clearTimeout(this.swapTimer);clearTimeout(this.headerSettle);clearTimeout(this.pressTimer);this.headerSettle=0;cancelAnimationFrame(this.headerFrame);this.headerSection?.removeAttribute('data-fn-hidden');this.abort?.abort();this.observer?.disconnect();[...this.panels||[],this.shade].filter(Boolean).forEach(node=>this.stopPanelAnimation(node));this.querySelectorAll('dialog[open]').forEach(d=>d.close());this.openPanel=null;this.activeTrigger=null;window.FiozatoPageScroll?.unlock(this.panelScrollToken); }
}
if(!customElements.get('fiozato-navigation'))customElements.define('fiozato-navigation',FiozatoNavigation);

  } catch(e) { console.error(e); }
})();
})();
